// components/Common/ExitTypeBadge.tsx
import React from "react";
import { useTranslation } from "react-i18next";

interface ExitTypeBadgeProps {
  exitType: 'morning' | 'afternoon' | 'early';
  text?: string;
}

const ExitTypeBadge: React.FC<ExitTypeBadgeProps> = ({ exitType, text }) => {
  const { t } = useTranslation();
  
  const getBadgeColor = () => {
    switch (exitType) {
      case 'morning':
        return 'success';
      case 'afternoon':
        return 'warning';
      case 'early':
        return 'info';
      default:
        return 'secondary';
    }
  };

  const getDefaultText = () => {
    switch (exitType) {
      case 'morning':
        return t('studentExit.exitType.morning');
      case 'afternoon':
        return t('studentExit.exitType.afternoon');
      case 'early':
        return t('studentExit.exitType.early');
      default:
        return t('unknown');
    }
  };

  const getExitTypeIcon = () => {
    switch (exitType) {
      case 'morning':
        return 'fas fa-sun';
      case 'afternoon':
        return 'fas fa-cloud-sun';
      case 'early':
        return 'fas fa-clock';
      default:
        return 'fas fa-circle';
    }
  };

  return (
    <span className={`badge badge-soft-${getBadgeColor()} d-inline-flex align-items-center`}>
      <i className={`${getExitTypeIcon()} me-1`}></i>
      {text || getDefaultText()}
    </span>
  );
};

export default ExitTypeBadge;